import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrl: './question.component.scss'
})
export class QuestionComponent {

  @Input() overlay = true;

  constructor(
    public element_ref: ElementRef<HTMLElement>
  ) { }

}
